// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__6qOus","requiredAsterisk":"Info_requiredAsterisk__3L711"};